import React from 'react'
const UserProfileContext = React.createContext({})

UserProfileContext.displayName = 'UserProfileContext'

export default UserProfileContext
